export function isMobile(maxWidth) {
  if (maxWidth === void 0) {
    maxWidth = '767px';
  }

  try {
    return window.matchMedia("only screen and (max-width: " + maxWidth + ")").matches;
  } catch (e) {
    return false;
  }
}